import { Link } from 'react-router-dom';
import Seo from '@/components/base/Seo';
import { siteInfo } from '@/mocks/news';
import { aboutSections, principleList, testimonialList } from '@/mocks/site';
import ContactForm from '@/pages/about/components/ContactForm';

const reviewSteps = [
  { step: '01', title: '汇集', desc: '从公开渠道抓取与读者投稿中汇集原始信息，保留出现时间。', icon: 'ri-inbox-archive-line' },
  { step: '02', title: '核对', desc: '比对来源数量与相互矛盾之处，确定信息状态标签。', icon: 'ri-search-eye-line' },
  { step: '03', title: '整理', desc: '按时间顺序排列公开节点，剔除个人信息与未证实的指控。', icon: 'ri-list-ordered' },
  { step: '04', title: '跟进', desc: '持续跟踪后续进展，在原条目内更新，必要时追加更正。', icon: 'ri-refresh-line' },
];

export default function About() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于黑料爆料',
      url: 'https://utuyxa.cn/about',
      description:
        '黑料爆料是专注娱乐与网络热点的实时情报站，坚持核实优先、标注信息状态、不公开个人隐私的内容原则。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '黑料爆料',
      url: 'https://utuyxa.cn/',
      email: siteInfo.email,
      description: siteInfo.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: '联系黑料爆料',
      url: 'https://utuyxa.cn/about#submit',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://utuyxa.cn/' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://utuyxa.cn/about' },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="关于我们 | 黑料爆料内容原则与投稿联系"
        description="了解黑料爆料的品牌定位、发展理念与内容原则：核实优先、标注信息状态、不公开个人隐私。页面底部提供投稿与联系表单，欢迎提供公开线索。"
        keywords="黑料爆料关于我们,黑料爆料内容原则,黑料爆料投稿,黑料爆料联系"
        path="/about"
        jsonLd={jsonLd}
      />

      <section className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-7">
            <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="transition-colors hover:text-primary-400">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-700">关于我们</span>
            </nav>
            <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl">
              关于
              <span className="text-primary-500">黑料爆料</span>
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              我们把散落在各个讨论群的碎片信息，按时间与热度重新排好，
              让每一位读者打开首页就能看见最新动态，也能看懂来龙去脉。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/#feed"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-flashlight-fill" />
                查看今日新瓜
              </Link>
              <a
                href="#submit"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-400"
              >
                <i className="ri-send-plane-line" />
                提供线索
              </a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="h-56 w-full overflow-hidden rounded-lg border border-background-200 md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20editorial%20workspace%20with%20deep%20charcoal%20desk%20surface%2C%20warm%20amber%20desk%20lamp%20glow%20and%20crimson%20accent%20light%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20artistic%20abstract%2C%20no%20people%20visible%2C%20film%20grain&width=1000&height=720&seq=gg-about-01&orientation=landscape"
                alt="黑料爆料编辑工作台抽象配图"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full">
        <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">我们是谁</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              一个专注娱乐与网络热点的实时情报站，覆盖九个内容圈子。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-400" />
                {siteInfo.email}
              </p>
              <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-time-line text-primary-400" />
                {siteInfo.workTime}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-10 lg:col-span-8">
            {aboutSections.map((section) => (
              <article key={section.heading} className="border-l-2 border-background-300 pl-6">
                <h3 className="font-heading text-2xl text-foreground-950">{section.heading}</h3>
                <div className="mt-4 flex flex-col gap-3">
                  {section.paragraphs.map((text) => (
                    <p key={text.slice(0, 12)} className="text-[15px] leading-8 text-foreground-700">
                      {text}
                    </p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
          <h2 className="flex items-center gap-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            <span className="h-6 w-1.5 rounded-full bg-primary-500" />
            内容原则
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {principleList.map((item) => (
              <article
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-200 text-accent-400">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <h3 className="mt-4 text-base font-label text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>

          <h2 className="mt-16 flex items-center gap-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            <span className="h-6 w-1.5 rounded-full bg-accent-500" />
            一条内容如何被处理
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {reviewSteps.map((item) => (
              <article
                key={item.step}
                className="relative rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="font-heading text-4xl text-background-300">{item.step}</span>
                <h3 className="mt-2 flex items-center gap-2 text-base font-label text-foreground-950">
                  <i className={`${item.icon} text-primary-400`} />
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full">
        <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
          <h2 className="flex items-center gap-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            <span className="h-6 w-1.5 rounded-full bg-secondary-500" />
            读者口碑
          </h2>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonialList.map((item) => (
              <blockquote
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-500" />
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.quote}</p>
                <footer className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full">
                    <img
                      src={item.avatar}
                      alt={`${item.name} 头像`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span>
                    <span className="block text-sm font-label text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      <section id="submit" className="w-full scroll-mt-20 border-t border-background-200 bg-background-100">
        <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 px-3 py-1.5 text-xs font-label text-foreground-600">
              <i className="ri-send-plane-line text-primary-400" />
              投稿与联系
            </span>
            <h2 className="mt-5 font-heading text-3xl text-foreground-950 md:text-4xl">
              有线索？
              <br />
              发给我们
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              建议同时说明信息来源与可公开的部分，编辑会按核查流程处理。
              你的邮箱仅用于回复，不会公开。
            </p>
            <ul className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400" />
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400" />
                {siteInfo.workTime}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-400" />
                不公开投稿人身份与联系方式
              </li>
            </ul>
          </div>
          <div className="lg:col-span-8">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}